import { TEXT_LINK_FOCUS_RING } from '../../../lib/a11yFocus'

type Props = {
	message: string
}

function ContactMessage({ message }: Props) {
	return (
		<div className='p-3 leading-6 text-base text-charcoal-900 rounded-lg bg-sun-500'>
			<p className='mb-2'>{message}</p>
			<p>
				<a className={`underline text-algae-500 ${TEXT_LINK_FOCUS_RING}`} href={`mailto: ${process.env.REACT_APP_SUPPORT_EMAIL}`}>
					Contact us
				</a>
				if you have a problem.
			</p>
		</div>
	)
}
export default ContactMessage
